import React, { ReactNode } from 'react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import styled from '@emotion/styled'
import { theme } from '../mui'

interface AuthLayoutProps {
  children: ReactNode | ReactNode[]
}

const S = {
  Container: styled.div`
    background-color: ${theme.palette.common.white};
    box-sizing: border-box;
    height: 100vh;
    width: 100%;
    overflow: hidden;
  `,
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <S.Container>
      <GoogleOAuthProvider clientId="371629267382-jsj0bo0cmi0ves6u3b5segm17ku0bdkp.apps.googleusercontent.com">
        {children}
      </GoogleOAuthProvider>
    </S.Container>
  )
}

export default AuthLayout
